import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "ExpressOrders mt-6" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_express_orders_filters = _resolveComponent("express-orders-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_express_status = _resolveComponent("express-status")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_express_link = _resolveComponent("express-link")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_page_title, { title: "Доставка за 3 часа" }),
    _createVNode(_component_express_orders_filters, {
      class: "mt-6",
      loading: _ctx.state.is_loading,
      onSearch: _ctx.applyFilters,
      onResetted: _ctx.resetFilters
    }, null, 8, ["loading", "onSearch", "onResetted"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.is_loading,
            text: "При получении заказов за 2 часа произошла ошибка",
            "error-message": _ctx.state.failure.error_state.message,
            "error-url": _ctx.state.failure.error_state.url,
            "error-status": _ctx.state.failure.error_state.status,
            onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadExpressOrders(_ctx.state.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 1,
            loading: _ctx.state.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                loading: _ctx.state.is_loading,
                columns: _ctx.ExpressOrderColumns,
                rows: _ctx.state.list,
                "with-limit": "",
                "pagination-limit": _ctx.filters_state.limit,
                "pagination-total-items": _ctx.state.pagination.total_items,
                "pagination-current-page": _ctx.state.pagination.current_page,
                "pagination-total-pages": _ctx.state.pagination.total_pages,
                onChangePage: _ctx.loadExpressOrders,
                onChangeLimit: _ctx.onLimitChange
              }, {
                td: _withCtx(({ row, column }) => [
                  (column.key === 'invoice_number' && row.invoice_number && row.id)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: "text-blue-500",
                        to: `/express/${row.id}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.invoice_number), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (row.company_name && column.key === 'company_name')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(`${row.company_name} (ID: ${row.company_id})`), 1)
                        ], 64))
                      : (row.senders && column.key === 'senders' && row.senders)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(row.senders.building), 1)
                          ], 64))
                        : (
                                row.receivers && column.key === 'receivers' && row.receivers[0]
                            )
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createTextVNode(_toDisplayString(row.receivers[0].building), 1)
                            ], 64))
                          : (row.price && column.key === 'price')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                _createTextVNode(_toDisplayString(_ctx.cutName(`${row.price || '-'}`, 25)), 1)
                              ], 64))
                            : (row.total_price && column.key === 'total_price')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                  _createTextVNode(_toDisplayString(_ctx.cutName(row.total_price, 25)), 1)
                                ], 64))
                              : (column.key === 'statusDescription')
                                ? (_openBlock(), _createBlock(_component_express_status, {
                                    key: 6,
                                    "is-added-to-accrual": row.is_added_to_accrual,
                                    "was-returned": row.was_returned,
                                    status: row.statusDescription,
                                    "status-number": row.status
                                  }, null, 8, ["is-added-to-accrual", "was-returned", "status", "status-number"]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                    _createTextVNode(_toDisplayString(_ctx.cutName(row[column.key], 12)), 1)
                                  ], 64))
                ]),
                actions: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_3, [
                    (_ctx.isCanAddToAccrual(row))
                      ? (_openBlock(), _createBlock(_component_the_button, {
                          key: 0,
                          class: "primary small mr-2",
                          loading: _ctx.state.is_loading,
                          onClick: ($event: any) => (_ctx.addToAccrual(row)),
                          hint: "Добавлено в начисление 1С"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 2
                        }, 1032, ["loading", "onClick"]))
                      : _createCommentVNode("", true),
                    (row.status === 2)
                      ? (_openBlock(), _createBlock(_component_express_link, {
                          key: 1,
                          id: row.id
                        }, null, 8, ["id"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
            ]),
            _: 1
          }, 8, ["loading"]))
    ])
  ]))
}